module.exports = __webpack_public_path__ + "static/media/RGM.ec467102.png";